// 📁 src/layouts/Category/data/DetailCategory.js
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Grid,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useColorTheme } from "context/ColorThemeContext";

function DetailCategory({ open, onClose, selectedCategory }) {
  const colors = useColorTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ "& .MuiDialog-paper": { width: "50% !important" } }}
    >
      <DialogTitle
        sx={{
          backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
          color: colors.popupText || "white",
          fontWeight: "bold",
          fontSize: "18px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        Thông tin danh mục
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container spacing={2} pt={1}>
            <Grid item xs={12} sm={6}>
              <Typography fontSize="14px">
                <strong>Mã danh mục:</strong> {selectedCategory?.code || "---"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography fontSize="14px">
                <strong>Tên danh mục:</strong> {selectedCategory?.name || "---"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography fontSize="14px">
                <strong>Trạng thái:</strong> {selectedCategory?.status === 1 ? "Hoạt động" : "Khóa"}
              </Typography>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
            color: colors.popupText || "white",
          }}
        >
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DetailCategory.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedCategory: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.number,
  }).isRequired,
};

export default DetailCategory;
